import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import "./style/Appdetail.css"
import Nav from "./nav"
import NativeBanner from './NativeBanner'
import AdBanner from './AdBanner'
import Footer from './Footer'
 
export default function Appdetails() {
    const [appDetails , setappDetails] =useState(null)
    const {id} = useParams()
    useEffect(() => {
    const fetchData = async () => {
        try {
            const res = await axios.get(
                `https://apkbackend-production-85e8.up.railway.app/allapp/${id}`
            );
            setappDetails(res.data);
        } catch (error) {
            console.log(error);
        }
    };

    fetchData();
}, [id]);
if(!appDetails){
    return <h1>Loading...</h1>
}
  return (
    <div >
        <Nav />
        <AdBanner />
        <div className="appdetails">
              <img src={appDetails.image} alt="" />
      <h2>{appDetails.title}</h2>
        
                <NativeBanner />
       <p>{appDetails.details}</p>
       <button><a href={appDetails.link}>Download</a></button>
  
        </div>
              
        <Footer/>
      </div>
  )
}
